module.exports = __webpack_public_path__ + "media/illustrations/free-gift-present-37d95f5e.svg";